import React, {createContext, useContext, useState} from 'react';

interface MusicKitProviderProps {
  children: React.ReactNode;
}

type MusicKitContextType = MusicKit.MusicKitInstance | null;
const MusicKitContextObject = createContext<MusicKitContextType>(null);

export function MusicKitProvider({children}: MusicKitProviderProps) {
  const [musicKit, setMusicKit] = useState<MusicKitContextType>(null);

  if (!musicKit) {
    fetchDeveloperToken((developerToken: string) => {
      const mk = window.MusicKit.configure({
        developerToken: developerToken,
        app: {
          name: 'music.fm.alto',
          build: '69.69.69',
        },
      });
      setMusicKit(mk);
    });
  }

  return (
    <MusicKitContextObject.Provider value={musicKit}>
      {children}
    </MusicKitContextObject.Provider>
  );
}

export function useMusicKitContext() {
  return useContext(MusicKitContextObject);
}

const fetchDeveloperToken = (tokenCallback: (token: string) => void) => {
  fetch(`${process.env.REACT_APP_API_NEXT_URL}/music-kit/dev-token`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((data) => {
      return tokenCallback(data.developerToken);
    })
    .catch((error) => {
      console.error('Error initializing music kit.');
      throw error;
    });
};
